/* eslint-disable no-shadow */
export const getDefaultState = () => ({
  toggle: {
    dashboardCollapsed: true,
    customerTab: false,
  },
});

export const state = getDefaultState();

export const types = {
  RESET: 'RESET',
  SET: 'SET',
  TOGGLE: 'TOGGLE',
};

export const mutations = {
  [types.RESET](state) {
    Object.assign(state, getDefaultState());
  },

  [types.SET](state, { type, value }) {
    state.toggle[type] = value;
  },

  [types.TOGGLE](state, type) {
    state.toggle[type] = !state.toggle[type];
  },
};

export const getters = {
  isCustomerTab: state => state.toggle.customerTab,
};

export const actions = {
  toggle({ commit }, type) {
    commit(types.TOGGLE, type);
  },

  set({ commit }, { type, value }) {
    commit(types.SET, { type, value });
  },

  setCustomerTab({ commit }, value) {
    commit(types.SET, { type: 'customerTab', value: !!value });
  },
};
